 export const enamadProduct = [
     {
         name: 'مسجد، حسینیه و نمازخانه',
         value: '1427',
     },
     {
         name: 'سایر تشکل‌ها و سازمان‌های عضویتی',
         value: '1516',
     },
     {
         name: 'سازمان‌ها و نهادهای بین‌المللی و منطقه‌ای',
         value: '1438',
     },
     {
         name: 'خدمات حمل جنازه، کفن و دفن',
         value: '1441',
     },
     {
         name: 'حمل‌ونقل زمینی مسافر درون شهری- هوشمند',
         value: '1003',
     },
     {
         name: 'حمل‌ونقل زمینی بار درون شهری- هوشمند',
         value: '1015',
     },
     {
         name: 'سایر خدمات پشتیبانی حمل‌ونقل- تجمیع، تفکیک و عدل‌بندی بار',
         value: '1032',
     },
     {
         name: 'خدمات پستی- پست الکترونیکی، پست صوتی و ...',
         value: '1038',
     },
     {
         name: 'سایرخدمات انبارداری ',
         value: '1043',
     },
     {
         name: 'وصول قبوض خدمات دولتی و عمومی- عوارض شهرداری، پارک خودرو و ... ',
         value: '1504',
     },
     {
         name: 'جمع‌سپاری مالی- هدیه‌محور ',
         value: '1053',
     },
     {
         name: 'مشاوره سرمایه‌گذاری بورس ',
         value: '1057',
     },
     {
         name: 'خدمات کارتخوان ',
         value: '1069',
     },
     {
         name: 'نمایندگی بیمه ',
         value: '1076',
     },
     {
         name: 'مشاوره معاملات ملک، زمین و ساختمان',
         value: '1083',
     },
     {
         name: 'کرایه سایر وسایل نقلیه ',
         value: '1087',
     },
     {
         name: 'کرایه سایر ماشین‌آلات و تجهیزات',
         value: '1093',
     },
     {
         name: 'سایر خدمات مراقبت اجتماعی',
         value: '1129',
     },
     {
         name: 'دامپزشکی',
         value: '1132',
     },
     {
         name: 'دفتر خدمات سیاحتی و جهانگردی ',
         value: '1135',
     },
     {
         name: 'رستوران و سالن غذاخوری',
         value: '1146',
     },
     {
         name: 'سایر خدمات فناوری اطلاعات',
         value: '1160',
     },
     {
         name: 'سایر محتوای برخط',
         value: '1187',
     },
     {
         name: 'گردآوری اطلاعات و تهیه خبر',
         value: '1189',
     },
     {
         name: 'خدمات مرکز تماس ',
         value: '1166',
     },
     {
         name: 'سایر خدمات معماری',
         value: '1196',
     },
     {
         name: 'سایر خدمات مشاوره مهندسی',
         value: '1206',
     },
     {
         name: 'سایر خدمات آزمایش و تحلیل',
         value: '1218',
     },
     {
         name: 'سایر خدمات طراحی تخصصی',
         value: '1227',
     },
     {
         name: 'خدمات کشاورزی (باغبانی، سم‌پاشی، هرس کردن، برداشت محصول و ...)',
         value: '1508',
     },
     {
         name: 'تحقیق و توسعه- فنی و مهندسی ',
         value: '1232',
     },
     {
         name: 'سایر خدمات حقوقی',
         value: '1243',
     },
     {
         name: 'سایر خدمات حسابداری، حسابرسی و مالیاتی ',
         value: '1248',
     },
     {
         name: 'سایر خدمات مشاوره مدیریت',
         value: '1257',
     },
     {
         name: 'سایر خدمات پشتیبانی کسب‌وکار',
         value: '1273',
     },
     {
         name: 'دفتر تبلیغاتی',
         value: '1260',
     },
     {
         name: 'مدرسه',
         value: '1276',
     },
     {
         name: 'آموزش در محل',
         value: '1299',
     },
     {
         name: 'مشاوره آموزشی ',
         value: '1301',
     },
     {
         name: 'سایر خدمات فرهنگی و هنری',
         value: '1318',
     },
     {
         name: 'سایر خدمات چاپ و نشر',
         value: '1323',
     },
     {
         name: 'خدمات‌ راهنمایی کوه‌، شکار و ...',
         value: '1337',
     },
     {
         name: 'فروش غیرمستقیم بلیت خدمات‌ تفریحی و سرگرمی',
         value: '1354',
     },
     {
         name: 'سایر خدمات ساخت‌وساز',
         value: '1371',
     },
     {
         name: 'نصب، تعمیر و نگهداری تجهیزات گرمایشی، سرمایشی و تهویه مطبوع ',
         value: '1373',
     },
     {
         name: 'نصب، تعمیر و نگهداری سایر ماشین‌آلات و تجهیزات',
         value: '1382',
     },
     {
         name: 'نصب، تعمیر و نگهداری رایانه‌، تجهیزات دیجیتال و لوازم جانبی',
         value: '1384',
     },
     {
         name: 'نصب، تعمیر و نگهداری لوازم خانگی برقی',
         value: '1388',
     },
     {
         name: 'تعمیر و نگهداری سایر وسایل حمل‌ونقل',
         value: '1400',
     },
     {
         name: 'نصب، تعمیر و نگهداری تجهیزات پزشکی، آزمایشگاهی، تشخیصی و موارد مشابه',
         value: '1392',
     },
     {
         name: 'شستشوی مبل، فرش، پرده و موارد مشابه ',
         value: '1402',
     },
]